import { useEffect } from "react";

export function useLockBodyScroll(lock = true) {
  useEffect(() => {
    if (lock) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = "hidden";  // block scroll

      return () => {
        document.body.style.overflow = originalStyle; // restore scroll
      };
    }
  }, [lock]);
}
